const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "https://api.horizondatawave.ai",
    logoUrl: process.env.REACT_APP_LOGO_URL || "https://api.horizondatawave.ai/static/favicon.png",
    sentryDSN: process.env.REACT_APP_SENTRY_DSN || "https://12102eafe2a23c58ddbcba5820a74e46@o4508301490978816.ingest.de.sentry.io/4508617103573072"
};

export default config;